import React, { Component } from 'react';
import Dialog from './Dialog';
import Portal from '../util/Portal';
class DialogWrap extends Component {
    constructor() {
        super(...arguments);
        this.saveDialog = (node) => {
            this._component = node;
        };
        this.getComponent = (extra = {}) => {
            return React.createElement(Dialog, Object.assign({ ref: this.saveDialog }, this.props, extra, { key: "dialog" }));
        };
        this.getContainer = () => {
            const { getContainer } = this.props;
            if (getContainer) {
                return getContainer(this);
            }
            const container = document.createElement('div');
            document.body.appendChild(container);
            return container;
        };
    }
    shouldComponentUpdate({ visible }) {
        const { props } = this;
        return !!(props.visible || visible);
    }
    render() {
        const { visible } = this.props;
        if (visible || this._component) {
            return React.createElement(Portal, { getContainer: this.getContainer }, this.getComponent());
        }
        return null;
    }
}
DialogWrap.defaultProps = {
    visible: false,
};
export default DialogWrap;
